import PropTypes from 'prop-types';

import { Block } from '@web-packages/library/layouts';
import CustomText, { types as customTextTypes } from '../../Atoms/CustomText';

import { Button } from './styled';
import types from './types';
import variants from './variants';

const customTextTypeHelper = (type) => {
  switch (type) {
    case types.small:
      return customTextTypes.textSmallMedium;
    case types.standard:
      return customTextTypes.textLead;
    case types.large:
      return customTextTypes.headingXL;
    default:
      return customTextTypes.textLead;
  }
};

const getDescriptionName = (hasChildren) => (hasChildren ? 'icon' : 'text');

const customTextWithPara = (type, text, children = null) => (
  <CustomText
    className={`icon-button-${getDescriptionName(children)}`}
    text={children ? '' : text}
    type={customTextTypeHelper(type)}
  >
    {children}
  </CustomText>
);

const IconButton = ({
  type,
  variant,

  text,
  textFirst,

  icon,

  onClick,

  className,
}) => {
  const IconSVG = icon;
  return (
    <Button
      cursorIsPointer
      onClick={onClick}
      variant={variant}
      textFirst={textFirst}
      className={className}
    >
      {customTextWithPara(type, text, <IconSVG />)}
      {text && <Block>{customTextWithPara(type, text)}</Block>}
    </Button>
  );
};

IconButton.propTypes = {
  type: PropTypes.oneOf(Object.values(types)),
  variant: PropTypes.oneOf(Object.values(variants)),

  // eslint-disable-next-line react/forbid-prop-types
  icon: PropTypes.any.isRequired,
  text: PropTypes.string,
  textFirst: PropTypes.bool,

  onClick: PropTypes.func.isRequired,

  className: PropTypes.string,
};
IconButton.defaultProps = {
  type: types.standard,
  variant: variants.darkBlue,

  text: '',
  textFirst: false,

  className: '',
};

export default IconButton;
